<p class="title">{{ title }}</p>
<p class="subtitle">{{ subtitle }}</p>
<div class="slider-wrapper">
  <mpro-range-slider
    [doubleSlider]="true"
    [input]="[rangeFilter.greaterThan || min, rangeFilter.lessThan || max]"
    (valueChanged)="sliderChanged($event)"
    [min]="min"
    [max]="max"
    [labelGap]="30"
    [step]="step"
    [minInterval]="minInterval"
    [authRanges]="authRanges"
    [customSteps]="customSteps"
    [labelFormat]="labelFormat"
    [sliderFormat]="sliderFormat"
    [customTicks]="customTicks"
    [valueFormat]="valueFormat"
    [dynamicRange]="dynamicRange"
    [clickableTicks]="true"
    (errorChanged)="onErrorChanged($event)"
  >
  </mpro-range-slider>
</div>
<mpro-alert *ngIf="error" [message]="error" [type]="'error'"></mpro-alert>
<mpro-text-input
  [title]="inputTitle || title"
  info="Max 12 characters"
  errorMsg="Max: 12 characters"
  [(ngModel)]="rangeFilter.name"
  [inputState]="inputState"
  (keyup)="keyup()"
  placeholder=""
></mpro-text-input>

<div class="buttons">
  <button
    class="mpro-btn mpro-btn-secondary"
    (click)="cancelClick()"
    stopClickPropagation
  >
    Cancel
  </button>
  <button
    class="mpro-btn mpro-btn-secondary"
    (click)="previewGroup()"
    stopClickPropagation
  >
    Preview
  </button>
  <button
    class="mpro-btn mpro-btn-primary"
    [disabled]="rangeFilter.name?.length === 0 || error"
    (click)="saveClick()"
    stopClickPropagation
  >
    Save
  </button>
</div>
